import "@perxis-auto/shared";
import "react";
import "../../../../features/filterValues/api/api.js";
import "../../../../features/filterValues/model/middleware/index.js";
import "../../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { COLLECTION_IDS } from "../../../../shared/config/collections.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import { DEFAULT_FILTERS_KEYS_MAP } from "../../../../shared/config/filters.js";
import "react-router";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import { selectSlice } from "../../../../shared/store/config/model/selectors/selectSlice.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import "../../../../shared/store/installation/model/slice.js";
import "../../../../shared/store/pagination/model/slice.js";
import "../../../../features/filterChoice/model/middleware/index.js";
import "../../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import "../../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import { selectFilterValues } from "../../../../features/filterChoice/model/selectors/selectFilterValues.js";
import "../../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import "../../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import "../../../../features/filterChoice/model/slice.js";
import { prepareRequestFilters } from "../../lib/prepareRequestFilters.js";
import "@perxis-auto/shared/lib";
import "../../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../../shared/lib/logger/index.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../api/api.js";
import "./selectCityParameters.js";
import "./selectDealershipParameters.js";
const selectCitiesParameters = createAppSelector(
  [selectSlice, selectFilterValues],
  (config, filterValues) => {
    const { [DEFAULT_FILTERS_KEYS_MAP.CITY]: cityValues, ...filtersWithoutCities } = filterValues;
    const qFilters = prepareRequestFilters(filtersWithoutCities);
    return {
      envId: config.envId,
      spaceId: config.spaceId,
      collectionId: COLLECTION_IDS.vehiclesVehicles,
      filter: { q: qFilters },
      options: {
        fields: { locations: "distinct(locations)" }
      }
    };
  }
);
export {
  selectCitiesParameters
};
